/**
 * @param {object} state
 * @param {string} timezone
 */
const setProfileTimezone = (state, timezone) => {
  state.timezone = timezone
}

export default {
  setProfileTimezone
}
